import React from 'react'

export interface SidebarContextType {
  collapsed: boolean
  toggle: () => void
}

export const SidebarContext = React.createContext<SidebarContextType>({
  collapsed: false,
  toggle: () => {},
})

export function useSidebarContext() {
  return React.useContext(SidebarContext)
}
